import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Project } from 'src/app/shared/models/project';
import { ESACopyProjectDialogComponent } from '../shared/esa-copy-project-dialog/esa-copy-project-dialog.component';
import { firstValueFrom } from 'rxjs';
import { SelectedProjectApiService } from 'src/app/shared/components/selected-project/selected-project.api.service';
import Swal from 'sweetalert2';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { UserLogicService } from 'src/app/shared/services/user.logic.service';
import { Constants } from 'src/app/shared/utils/constants';
import { EPAProjectInputsService } from './esa-setup-inputs.api.service';
import { UdlOverlapToolContainerService } from '../../udl-overlap-tool-container.service';

@Component({
  selector: 'app-esa-setup-inputs',
  templateUrl: './esa-setup-inputs.component.html',
  styleUrls: ['./esa-setup-inputs.component.css']
})
export class ESASetupInputsComponent implements OnChanges {

  @Input() selectedProject?: Project;
  @Input() currentUserName: string = "";
  @Input() canMakeEdits: boolean = false;

  createdBy: string = "";

  @Output() onQueryFilterChangeEvent = new EventEmitter<string>();
  @Output() isSetupValidEvent = new EventEmitter<boolean>();

  isProjectNameValid: boolean = true;
  isProjectNameDuplicated: boolean = false;
  loading: boolean = false;
  isArchiveButtonDisabled: boolean = true;
  @ViewChild('appDialog') copyprojectDialog!: ESACopyProjectDialogComponent;

  constructor(
    private userService: UserLogicService,
    public projectApiService: SelectedProjectApiService,
    private projectInputsService: EPAProjectInputsService,
    private overLapToolContainerService: UdlOverlapToolContainerService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedProject']) {
      this.createdBy = this.selectedProject ? this.selectedProject.createdBy ? this.selectedProject.createdBy : "" : this.currentUserName;
      this.validateSelectedProject();
      this.projectInputsService.resetChangeDetection();
    }

    this.setArchiveButtonStatus();
  }

  onQueryFilterEvent({ query }: AutoCompleteCompleteEvent) {
    this.onQueryFilterChangeEvent.emit(query);
  }

  async projectNameChanged(value: string) {
    this.isProjectNameValid = value.length > 0;
    this.isProjectNameDuplicated = false;
    await firstValueFrom(this.projectApiService.projects).then(projects => {
      if (projects.find(p => p.name == value && p.name != '' && p.projectPk != this.selectedProject?.projectPk)) {
        this.isProjectNameValid = false;
        this.isProjectNameDuplicated = true;
      }
    });
    if (!this.selectedProject) return;
    this.selectedProject.name = value;
    this.projectInputsService.setProjectNameAndDescriptionChanged();
    this.validateSetupInfoInProject();
  }

  projectDescriptionChanged(value: string) {
    if (!this.selectedProject) return;
    this.selectedProject.description = value;
    this.projectInputsService.setProjectNameAndDescriptionChanged();
  }

  validateSelectedProject() {
    this.isProjectNameValid = this.selectedProject?.name ? this.selectedProject?.name.length > 0 : false;

    this.validateSetupInfoInProject();
  }

  validateSetupInfoInProject() {
    if (this.selectedProject?.name && this.isProjectNameValid) {
      this.isSetupValidEvent.emit(true);
      return;
    }
    this.isSetupValidEvent.emit(false);
  }

  onImportClicked() {
    if (this.selectedProject?.name != "")
      this.copyprojectDialog.showDialog(true, this.selectedProject?.projectPk);
  }

  onImportProjectSelected(event: any) {
    const projectPkToCopyDataFrom = event.projectPkCopy;
    const isCurrentProjectNew = this.selectedProject?.projectPk == -1;

    this.loading = true;

    if (isCurrentProjectNew) {
      this.importProjectInputs(projectPkToCopyDataFrom);
    }
    else {
      Swal.fire({
        text: 'Do you want to overwrite the project data?',
        showCancelButton: true,
        confirmButtonColor: '#0069be',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        icon: 'warning'
      }).then((result) => {
        if (result.value) {
          this.importProjectInputs(projectPkToCopyDataFrom);
        }
        else {
          this.loading = false;
        }
      });
    }
  }

  importProjectInputs(projectPkToCopyDataFrom: number) {
    this.overLapToolContainerService.setProjectToBeImported(projectPkToCopyDataFrom);
    this.projectInputsService.getAndSetInputsEvent.emit(projectPkToCopyDataFrom);
    Swal.fire({
      text: 'Project imported successfully',
      confirmButtonColor: '#0069be',
      confirmButtonText: 'Ok',
      icon: 'success'
    });
    this.loading = false;
  }

  archiveProject() {
    if (this.selectedProject?.name != undefined && this.selectedProject?.name != '')
      if (this.selectedProject?.name != undefined && this.selectedProject?.name != '')
        Swal.fire({
          text: 'Do you want to archive the current project?',
          showCancelButton: true,
          confirmButtonColor: '#0069be',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          icon: 'warning'
        }).then((result) => {
          if (result.value) {
            if (this.selectedProject) {
              this.selectedProject.active = false;
              this.projectApiService.saveProject(Constants.FEATURE_ACRONYM.ESA_ASSESSMENT_UDL).subscribe(data => {
                this.loading = false;
                Swal.fire({
                  text: 'Project archived successfully',
                  confirmButtonColor: '#0069be',
                  confirmButtonText: 'Ok',
                  icon: 'success'
                }).then((result) => {
                  if (result.value)
                    location.reload();
                });
              });
            }
          }
          else {
            this.loading = false;
          }
        });
  }

  setArchiveButtonStatus() {
    this.isArchiveButtonDisabled = !this.selectedProject || this.userService.profile.displayName !== this.selectedProject?.createdBy || !this.userService.currentUserCanRunModels();
  }
}
